var map = {
	"./dummy": 2,
	"./dummy.png": 2,
	"./favicon/android-icon-144x144": 3,
	"./favicon/android-icon-144x144.png": 3,
	"./favicon/android-icon-192x192": 4,
	"./favicon/android-icon-192x192.png": 4,
	"./favicon/android-icon-36x36": 5,
	"./favicon/android-icon-36x36.png": 5,
	"./favicon/android-icon-48x48": 6,
	"./favicon/android-icon-48x48.png": 6,
	"./favicon/android-icon-72x72": 7,
	"./favicon/android-icon-72x72.png": 7,
	"./favicon/android-icon-96x96": 8,
	"./favicon/android-icon-96x96.png": 8,
	"./favicon/apple-icon": 9,
	"./favicon/apple-icon-114x114": 10,
	"./favicon/apple-icon-114x114.png": 10,
	"./favicon/apple-icon-120x120": 11,
	"./favicon/apple-icon-120x120.png": 11,
	"./favicon/apple-icon-144x144": 12,
	"./favicon/apple-icon-144x144.png": 12,
	"./favicon/apple-icon-152x152": 13,
	"./favicon/apple-icon-152x152.png": 13,
	"./favicon/apple-icon-180x180": 14,
	"./favicon/apple-icon-180x180.png": 14,
	"./favicon/apple-icon-57x57": 15,
	"./favicon/apple-icon-57x57.png": 15,
	"./favicon/apple-icon-60x60": 16,
	"./favicon/apple-icon-60x60.png": 16,
	"./favicon/apple-icon-72x72": 17,
	"./favicon/apple-icon-72x72.png": 17,
	"./favicon/apple-icon-76x76": 18,
	"./favicon/apple-icon-76x76.png": 18,
	"./favicon/apple-icon-precomposed": 19,
	"./favicon/apple-icon-precomposed.png": 19,
	"./favicon/apple-icon.png": 9,
	"./favicon/favicon-16x16": 20,
	"./favicon/favicon-16x16.png": 20,
	"./favicon/favicon-32x32": 21,
	"./favicon/favicon-32x32.png": 21,
	"./favicon/favicon-96x96": 22,
	"./favicon/favicon-96x96.png": 22,
	"./favicon/favicon.ico": 51,
	"./favicon/ms-icon-144x144": 23,
	"./favicon/ms-icon-144x144.png": 23,
	"./favicon/ms-icon-150x150": 24,
	"./favicon/ms-icon-150x150.png": 24,
	"./favicon/ms-icon-310x310": 25,
	"./favicon/ms-icon-310x310.png": 25,
	"./favicon/ms-icon-70x70": 26,
	"./favicon/ms-icon-70x70.png": 26,
	"./founders/founder_0": 27,
	"./founders/founder_0.jpg": 27,
	"./founders/founder_1": 28,
	"./founders/founder_1.jpg": 28,
	"./founders/founder_2": 29,
	"./founders/founder_2.jpg": 29,
	"./home_header_bg": 30,
	"./home_header_bg.jpg": 30,
	"./marker": 31,
	"./marker.png": 31,
	"./og": 32,
	"./og.png": 32,
	"./svg/facebook": 33,
	"./svg/facebook.svg": 33,
	"./svg/instagram": 34,
	"./svg/instagram.svg": 34,
	"./svg/logo": 35,
	"./svg/logo.svg": 35,
	"./svg/logo_2": 36,
	"./svg/logo_2.svg": 36,
	"./svg/logo_diputacio": 37,
	"./svg/logo_diputacio.svg": 37,
	"./svg/logo_eclectick": 38,
	"./svg/logo_eclectick.svg": 38,
	"./svg/logos_footer": 39,
	"./svg/logos_footer.svg": 39,
	"./svg/logos_footer_m": 40,
	"./svg/logos_footer_m.svg": 40,
	"./svg/newsletter": 41,
	"./svg/newsletter.svg": 41,
	"./svg/play": 42,
	"./svg/play.svg": 42,
	"./svg/quotes": 43,
	"./svg/quotes.svg": 43,
	"./svg/tiktok": 44,
	"./svg/tiktok.svg": 44,
	"./svg/twitter": 45,
	"./svg/twitter.svg": 45,
	"./svg/youtube": 46,
	"./svg/youtube.svg": 46
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;